module.exports = __webpack_public_path__ + "static/media/glasses.b1c7d54f.png";